/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Search_1Inputs */

const en_pc_tut_search_1 = /** @type {(inputs: Pc_Tut_Search_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the find bar from the toolbar or the command palette.`)
};

const zh_pc_tut_search_1 = /** @type {(inputs: Pc_Tut_Search_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从工具栏或命令面板打开查找栏。`)
};

/**
* | output |
* | --- |
* | "Open the find bar from the toolbar or the command palette." |
*
* @param {Pc_Tut_Search_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_search_1 = /** @type {((inputs?: Pc_Tut_Search_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Search_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_search_1(inputs)
	return zh_pc_tut_search_1(inputs)
});
export { pc_tut_search_1 as "pc.tut.search.1" }